
import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import Grid from '../../../../common/Grid';
import { Skeleton } from '../../../../common/Skeleton';

const styles = () => ({
  width: '100%',
  '.dn-notifications': {
    marginTop: '-2px !important',
    marginLeft: '-2px !important',
    '& > div.MuiGrid-item': {
      paddingLeft: '2px !important',
      paddingTop: '2px !important',
    },
    '& > div:first-of-type': {
      background: '#FAFAFA',
    },
    '.dn-notification': {
      padding: '19px 40px',
      '.dn-summary': {
        fontSize: '15px',
        marginRight: '5px',
        display: 'flex',
        alignItems: 'center',
      },
      '.dn-item-title': {
        width: '400px',
        maxWidth: '100%',
      },
      '.dn-date': {
        marginLeft: '5px',
        width: '125px',
        maxWidth: '100%',
      },
      '.dn-detail': {
        marginLeft: '5px',
        width: '100px',
        maxWidth: '100%',
      },
    },
  },
  '.dn-notification-title': {
    fontSize: '16px',
    borderBottom: '1px solid rgba(75, 75, 75, 0.1)',
    paddingBottom: '15px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
    paddingLeft: '40px',
    paddingRight: '40px',
    position: 'sticky',
    top: '0',
    zIndex: '1',
    background: '#fff',
  },
  '.dn-notifications-status-icon': {
    marginRight: '20px',
  },
  '.dn-toolbar &': {
    '.dn-notifications': {
      '.dn-notification': {
        '.dn-item-title': {
          width: '125px',
        },
        '.dn-date': {
          width: '75px',
        },
        '.dn-detail': {
          width: '50px',
        },
      },
    },
  },
});

export const SkeletonNotification = ({ maxRows = 3 }) => (
  <Box sx={styles}>
    <Typography className="dn-notification-title">
      <Skeleton variant="text" height={36} width={75} />
    </Typography>
    <Box>
      <Grid className="dn-notifications" container>
        {
          [...Array(maxRows)].fill().map((_, i) => (
            <Grid key={i} item xs={12}>
              <Box className="dn-flex-between dn-flex-middle dn-notification">
                <Box className="dn-flex-middle">
                  <Skeleton className="dn-notifications-status-icon" variant="circular" width={22} height={22} />
                  <Typography className="dn-summary">
                    <Skeleton className="dn-item-title" variant="text" />
                    <Skeleton className="dn-date" variant="text" />
                    <Skeleton className="dn-detail" variant="text" />
                  </Typography>
                </Box>
                <Box>
                  <Skeleton variant="circular" width={22} height={22} />
                </Box>
              </Box>
            </Grid>
          ))
        }
      </Grid>
    </Box>
  </Box>
);

SkeletonNotification.propTypes = {
  maxRows: PropTypes.number,
};
